// extracted by mini-css-extract-plugin
module.exports = {"faq-right-shapes":"styles_faq-right-shapes__bvG1a"};